import type { MediaImage, Profile } from "./terra-boa-data";
import type { ProfileMediaRecord } from "./terra-boa-repository";

export function accountAvatar(photoURL?: string | null): MediaImage | undefined {
  if (!photoURL) return undefined;
  try {
    const url = new URL(photoURL);
    if (url.protocol !== "https:") return undefined;
    return { id: "account-avatar", url: url.href, alt: "Foto da conta" };
  } catch { return undefined; }
}

export function indexProfilePhotos(records: Record<string, ProfileMediaRecord>) {
  const photos = new Map<string, MediaImage>();
  for (const record of Object.values(records)) {
    if (!record.avatar?.url) continue;
    for (const key of [record.profileId, record.ownerUid]) {
      if (!key) continue;
      const existing = photos.get(key);
      if (!existing || existing.id === "account-avatar") photos.set(key, record.avatar);
    }
  }
  return photos;
}

export function profileAvatar(profile: Pick<Profile, "id" | "avatar"> & { ownerUid?: string }, photos: Map<string, MediaImage>, storeAvatar?: MediaImage, providerAvatar?: MediaImage) {
  const candidates = [photos.get(profile.id), profile.ownerUid ? photos.get(profile.ownerUid) : undefined, profile.avatar, storeAvatar];
  return candidates.find((image) => image?.url && image.id !== "account-avatar")
    ?? candidates.find((image) => image?.url)
    ?? providerAvatar;
}

export function shouldSyncAccountAvatar(existing: MediaImage | undefined, incoming: MediaImage) {
  return !existing?.url || (existing.id === "account-avatar" && existing.url !== incoming.url);
}
